export default {
  "status-error-text": "fichier est non conforme, veuillez le revalider",
  "autre-document": "Autre document",
};
